"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _InfiniteScroll = _interopRequireDefault(require("./InfiniteScroll"));
var _LoadMore = _interopRequireDefault(require("./LoadMore"));
var _Pagination = _interopRequireDefault(require("./Pagination"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SuperPager = function SuperPager(props) {
  var type = props.type;
  switch (type) {
    case "pagination":
      return /*#__PURE__*/_react["default"].createElement(_Pagination["default"], props);
    case "loadMore":
      return /*#__PURE__*/_react["default"].createElement(_LoadMore["default"], props);
    case "infiniteScroll":
      return /*#__PURE__*/_react["default"].createElement(_InfiniteScroll["default"], props);
    default:
      throw new Error("Specified type is invalid");
  }
};
var _default = SuperPager;
exports["default"] = _default;